export default __webpack_public_path__ + "static/media/36I-114288_-21008_0.faef5ec3.jpg";